import React, { Component } from 'react'
import styled from 'styled-components'

// Only load Hammer if in the browser.
const isBrowser = typeof window !== 'undefined'
const Hammer = isBrowser ? require('hammerjs') : undefined

export default class HammerComponent extends Component {
  static displayName = 'Hammer'

  static defaultProps = {
    initialScale: 1,
    initialX: 0,
    initialY: 0,
  }

  constructor(props, ...args) {
    super(props, ...args)

    this.state = {
      initialScale: props.initialScale,
      initialX: props.initialX,
      initialY: props.initialY,
      scale: props.initialScale,
      x: props.initialX,
      y: props.initialY,
    }
  }

  componentDidMount() {
    if (!isBrowser) return
    if (!this.container) throw new Error('Container ref could not be found')

    this.manager = new Hammer.Manager(this.container)

    const pinch = new Hammer.Pinch()
    const pan = new Hammer.Pan()

    pinch.recognizeWith(pan)

    this.manager.add([pinch, pan])
    this.manager.on(
      'panleft panright panup pandown pinchin pinchout',
      this.setLiveValues.bind(this),
    )
    this.manager.on('pinchend panend', this.setFinalVals.bind(this))
  }

  componentWillUnmount() {
    if (this.hammer) {
      this.manager.stop()
      this.manager.destroy()
    }

    this.manager = null
  }

  setLiveValues(vals) {
    const { initialX, initialY, initialScale } = this.state
    const { deltaX, deltaY, scale } = vals

    this.setState({
      scale: initialScale * scale,
      x: initialX + deltaX,
      y: initialY + deltaY,
    })
  }

  setFinalVals(vals) {
    const { initialX, initialY, initialScale } = this.state
    const { deltaX, deltaY, scale } = vals

    this.setState({
      initialScale: initialScale * scale,
      initialX: initialX + deltaX,
      initialY: initialY + deltaY,
    })
  }

  render() {
    const { children, ...props } = this.props
    const { x, y, scale } = this.state

    return (
      <div ref={comp => (this.container = comp)} {...props}>
        {children(x, y, scale)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hammer.js